import React from 'react';
import { useClasses, IStyles } from 'app/utils/css';
import { NumericBreakpoint } from 'app/constants/Breakpoints';
import { usePageBreakpoint } from 'app/components/layout/Breakpoint';

const BASE_FONT_STYLES: IStyles = {
  color: '#404040',

  // Make FontStyles transpire all flex and display properties,
  // making it transparent to the layout
  display: 'inherit',
  flexDirection: 'inherit',
  justifyContent: 'inherit',
  alignItems: 'inherit',
  flexGrow: 'inherit',
};

const FontStyles: React.FC = ({ children }) => {
  const breakpoint = usePageBreakpoint();
  const classes = useClasses({
    fontStylesNarrow: {
      ...BASE_FONT_STYLES,
      fontSize: '14px',
    },
    fontStylesWide: {
      ...BASE_FONT_STYLES,
      fontSize: '16px',
    },
  });
  return (
    <div
      className={
        breakpoint <= NumericBreakpoint.Narrow ? classes.fontStylesNarrow : classes.fontStylesWide
      }
    >
      {children}
    </div>
  );
};

export default FontStyles;
